<template>
  <b-card class="BlogPost__card">
    <div v-html="blogData.body"></div>
  </b-card>
</template>

<script>
import blogData from "./blog-data.js";

export default {
  metaInfo() {
    return this.blogData.metaInfo;
  },
  created() {
    this.blogData = blogData.find((v) => v.slug === this.$route.params.blogPost);
    if (!this.blogData) {
      this.blogData = {
        metaInfo: {
          title: "404 Not Found",
        },
        body: `
          <h1>404 Not Found</h1>
        `,
      };
    }
  },
};
</script>

<style>
.BlogPost__card {
  padding-top: 1rem;
}
</style>